module.exports = __webpack_public_path__ + "img/vest31.37530926.jpg";